module.exports = __webpack_public_path__ + "img/case.fa922191.png";